import * as React from 'react';
import { SsqImages } from 'images/SsqImages';
import { langutil } from 'language/langutil';
import svcs from 'services';
import { i18ntrans, tc } from 'language/i18nkey';
import { useLoginInfo } from 'hooks/useLoginInfo';
import { useZstdInfo } from 'zstd/useZstdInfo';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import icon_user from './icon/user.svg';

type Props = {};
export const RenderUserMypage = (props: Props) => {
  const { country, lang } = langutil.splitLangCode(svcs.svcLang.lang());
  const trans = (key: string): string => {
    return i18ntrans.header(key as any);
  };
  const loginInfo = useLoginInfo();
  const { setShowUserPopup } = useZstdInfo();
  return (
    <UserMypage>
      <button>
        <Link
          to={`/${country}/${lang}/myPage`}
          state={{ id: loginInfo?.userId }}
          onClick={() => {
            window.location.pathname === `/${country}/${lang}/myPage` && window.location.reload();
            setShowUserPopup(false);
          }}
        >
          <div className="alarm-active">
            <img alt={'popup_mypage.svg'} src={icon_user} />
            {/*{this.state.alertNewAlarm ? <span className={"circle"}/> : null}*/}
            {/* {trans("I18N_TITLE_MYPAGE")} */}
            {tc('i18n_head_menu_mypage')}
          </div>
        </Link>
      </button>
    </UserMypage>
  );
};

const UserMypage = styled.div`
  padding: 0 1rem;
  & button {
    padding: 0rem 0.6rem;
    border-radius: 0.4rem;
    &:hover {
      background-color: #e5e5e5;
    }
  }
  .alarm-active {
    position: relative;
    display: inline-block;

    .circle {
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #e6003e;
      border-radius: 100%;
      position: absolute;
      left: 20px;
    }
  }
`;
